module.exports = __webpack_public_path__ + "static/media/bitcoin_for_all.06ba0247.png";